import React from 'react';
import { PURCHASES_STATUS } from '../../../../utils/constants/purchases-status';
import SelectCheckbox from '../../../../shared/select-checkbox';


interface IPurchaseFilters {
    selectedStatus?: any;
    onClickFilter: (value: any, type?: string) => void;
}

const PurchaseFilters = ({
    selectedStatus,
    onClickFilter
}: IPurchaseFilters) => {
    return (
        <div>
            <div className='grid grid-cols-4 gap-4'>
                <SelectCheckbox
                    name='Status'
                    dataQa={'status-filter'}
                    placeholder={''}
                    options={PURCHASES_STATUS || []}
                    selectStyle={{ backgroundColor: '#ffffffa4', borderRadius: '4px', minWidth: 200 }}
                    onChangeSelectedOption={onClickFilter}
                    selectedOption={selectedStatus}
                    uniqueName={'status'}
                />
            </div>
        </div>
    );
};

export default PurchaseFilters;
